import { FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Typography, Box } from "@mui/material";

const currencies = ['R-ZAR', '$-USD', '$-AUS'];
const measurementSystems = [
    { value: 'Metric', label: 'Metric - m3' },
    { value: 'Imperial', label: 'Imperial - yrd3' }
];

const Step1Form = ({
    currency,
    setCurrency,
    measurementSystem,
    setMeasurementSystem,
}) => {
    const handleChange = (setter) => ({ target: { value } }) => {
        setter(value);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                <Typography variant="h6">
                    Choose Currency and Measurement System
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-around' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
                    <FormControl component="fieldset">
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <FormLabel component="legend">Currency</FormLabel>
                            <RadioGroup
                                label="currency"
                                name="currency"
                                value={currency}
                                onChange={handleChange(setCurrency)}
                            >
                                {currencies.map((curr) =>
                                    <FormControlLabel
                                        key={curr}
                                        value={curr}
                                        control={<Radio sx={{ display: 'flex', p: 0 }} />}
                                        label={curr}
                                        sx={{ display: 'flex', gap: 1 }}
                                    />
                                )}
                            </RadioGroup>
                        </Box>
                    </FormControl>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                    <FormControl component="fieldset">
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <FormLabel component="legend">Measurement System</FormLabel>
                            <RadioGroup
                                label="measurement system"
                                name="measurement-system"
                                value={measurementSystem}
                                onChange={handleChange(setMeasurementSystem)}
                            >
                                {measurementSystems.map(({ value, label }) =>
                                    <FormControlLabel
                                        key={value}
                                        value={value}
                                        control={<Radio sx={{ display: 'flex', alignItems: 'center', p: 0 }} />}
                                        label={label}
                                        sx={{ display: 'flex', gap: 1 }}
                                    />

                                )}
                            </RadioGroup>
                        </Box>
                    </FormControl>
                </Box>
            </Box>
        </Box>
    );
};

export default Step1Form;
